export enum KamPriority {
  High = 'high',
  Medium = 'medium',
  Low = 'Low',
}
